import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.managerOverwrites.loading,
  writing: state.managerOverwrites.writing,
  overwrites: state.managerOverwrites.overwrites,
  writeError: state.managerOverwrites.writeError,
  fetchOverwriteError: state.managerOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
